import React from 'react';
import Routers from './Route';
import AnimationThemeProvider from './_helper/AnimationTheme/AnimationThemeProvider';
import CustomizerProvider from './_helper/Customizer/CustomizerProvider';
import { ProspectAuthProvider } from './Auth/ProspectAuthContext';

const App = () => (
  <div className='App'>
    <ProspectAuthProvider>
      <CustomizerProvider>
        <AnimationThemeProvider>
          <Routers />
        </AnimationThemeProvider>
      </CustomizerProvider>
    </ProspectAuthProvider>
  </div>
);

export default App;
